import React from 'react';
import Checkbox from 'v2/form/Checkbox/Checkbox';
import repeat_icon from 'v2/icons/repeat.svg';
import styles from './extendedRequest.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'v2/models';
import { PERMISSION_NAME, hasPermission } from 'v2/utils/permissions';
import {
  Control,
  Controller,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { CreateSearchFormData } from '../../CreateSearchSchema';
import RadioButton from 'v2/form/RadioButton/RadioButton';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';

export const EXTENDED_REQUEST_MESSAGE = `Extended requests will continue to look for relevant providers
                                  as they enter the marketplace. If this is not selected, your request
                                  will only connect to providers who are currently in the marketplace today.`;

interface IExtendedRequestProps {
  register: UseFormRegister<CreateSearchFormData>;
  getValues: UseFormGetValues<CreateSearchFormData>;
  setValue: UseFormSetValue<CreateSearchFormData>;
  control: Control<CreateSearchFormData>;
}

const ExtendedRequest = ({
  register,
  getValues,
  setValue,
  control,
}: IExtendedRequestProps) => {
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );

  const has_is_extended_permission = hasPermission(permissions, [
    PERMISSION_NAME.EXTENDED_REQUESTS,
  ]);

  const { expiration_method } = getValues();

  const { onChange: changeMethod, ...restMethod } =
    register('expiration_method');

  const handleChangeExpirationMethod: typeof changeMethod = async (event) => {
    const newValue = event.target.value;
    if (newValue === 'manually_archive') {
      setValue('expires_at', '');
    }
    changeMethod(event);
  };
  const isExtended = getValues('extended');

  if (!has_is_extended_permission) {
    return null;
  }

  return (
    <div className={styles.isExtended}>
      <Checkbox label="" register={register('extended')} />
      <div>
        <div>
          <img src={repeat_icon} alt="extended" className={styles.icon} />
          <span className={styles.title}>Extended Request</span>
        </div>
        <p className={styles.message}>{EXTENDED_REQUEST_MESSAGE}</p>
        {isExtended ? (
          <div>
            <RadioButton
              label="Expiration"
              options={[
                {
                  value: 'manually_archive',
                  label: 'I will manually archive this Request',
                },
                {
                  value: 'date',
                  label: 'Select a date to archive this request',
                },
              ]}
              register={{
                onChange: handleChangeExpirationMethod,
                ...restMethod,
              }}
            />
            {expiration_method === 'date' ? (
              <Controller
                name="expires_at"
                control={control}
                render={({ field: { onChange, value } }) => {
                  const val = value ? moment(value) : null;
                  return (
                    <DatePicker
                      value={val}
                      minDate={moment().add(1, 'day')}
                      onChange={(val) => onChange(val?.toISOString())}
                    />
                  );
                }}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ExtendedRequest;
